import { Injectable } from "@angular/core";
import { IID_OL_RISOLUZIONE } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolRisoluzioneStore } from "./iidOlRisoluzione.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_RISOLUZIONE)
export class IIDolRisoluzioneQuery extends AbstractInterfaceDataQuery<IID_OL_RISOLUZIONE> {
  constructor(protected store: IIDolRisoluzioneStore) {
    super(store);
  }
}
